import React, { useState } from 'react'
import useSWR from "swr";
import axios from "axios";

import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

const Gallery = () => {
  const [open, setOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const fetcher = async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      console.error("Axios fetch error:", err.response || err);
      throw err; // important: SWR needs the error to trigger
    }
  };
  // Replace API_ENDPOINT with the actual API endpoint
  const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_SCHOOL}/items/gallery?fields=*.*.*&status=published`;
  const { data, error } = useSWR(API_ENDPOINT, fetcher);
    
  if (error) {
    return <div>Error loading data</div>;
  }

  if (!data) {
    return <div>Loading...</div>;
  }

  // Extract the image data from the API response
  const images = data.data;
  console.log("check", images)

  const slides = images.map((item) => ({
    src: item?.photo?.data?.full_url?.replace('http://', 'https://'),
  }));
  return (
    <>

      <div className="container-fluid">
        <div className="first">
          {
            images.map((item, i) => {
              console.log("check", item)
              return (
                <div key={i} className="one" >
                  <img src={item?.photo?.data?.full_url?.replace('http://', 'https://')}
                    className="mt-3 imght" alt={`school ${i}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setPhotoIndex(i);
                      setOpen(true);
                    }}
                  />
                </div>
              )
            })
          }
        </div>
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={slides}
          index={photoIndex}
          plugins={[Thumbnails]}
        />

      </div>

    </>
  )
}

export default Gallery
